<template>
  <BaseLayout title="Help">
    <!-- Main Content (Center) -->
    <div class="container my-4">
      <h1 class="display-4 text-center">Help & Tips</h1>
      <div class="markdown-content">
        <br>
        <div v-html="markdownContent"></div>
        <br>
        <hr>
        <br>
        <div v-if="isTeacher">
          <h3>Display only for Teachers</h3>
          <div v-html="teacherMarkdownContent"></div>
        </div>
      </div>
    </div>

    <!-- Right Sidebar Slot -->
    <template v-slot:right-sidebar>
      <div class="card p-3">
        <h5 class="card-title">Navigation:</h5>
        <button class="btn btn-info mb-2" @click="scrollToCleanup('docker_commands')">Docker commands</button>
        <button class="btn btn-info mb-2" @click="scrollToCleanup('documentation')">Documentation</button>
        <button class="btn btn-info mb-2" @click="scrollToCleanup('hw_file_structure')">HW File Structure</button>
        <button class="btn btn-info" @click="scrollToCleanup('faq')">FAQ</button>
      </div>
      <div v-if="isTeacher" class="card p-3 mt-3">
        <h5 class="card-title">For teachers:</h5>
        <button class="btn btn-info mb-2" @click="scrollToCleanup('worker_evaluation')">Worker Evaluation</button>
        <button class="btn btn-info" @click="scrollToCleanup('pre_check')">Pre-check</button>
      </div>
    </template>
  </BaseLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseLayout from '@/components/BaseLayout.vue';
import { marked } from 'marked';
// Import raw markdown content
import helpMarkdown from 'raw-loader!@/assets/help.md';
import teacherHelpMarkdown from 'raw-loader!@/assets/teacher_help.md';

export default {
  name: 'HelpView',
  components: {
    BaseLayout,
  },
  computed: {
    ...mapGetters(['isTeacher']),
    markdownContent() {
      // Use imported markdown content
      return marked.parse(helpMarkdown);
    },
    teacherMarkdownContent() {
      // Use imported teacher markdown content
      return marked.parse(teacherHelpMarkdown);
    }
  },
  methods: {
    scrollToCleanup(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  mounted() {
    // Check if there is a hash in the URL and scroll to the element if present
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }
};
</script>
